/**
 * Parses a comma-delimited flags string and returns a set of flags for easy lookup.
 *
 * @param flagsString - A comma-delimited string of flags
 * @returns A Set of flag names, or an empty set if flagsString is empty or invalid
 */
export const parseFlags = (flagsString?: string): Set<string> => {
  if (!flagsString || typeof flagsString !== "string") {
    return new Set();
  }

  return new Set(
    flagsString
      .split(",")
      .map(flag => flag.trim())
      .filter(flag => flag.length > 0),
  );
};

/**
 * Checks if a specific flag is present in the flags set.
 *
 * @param flagsString - A comma-delimited string of flags
 * @param flagName - The name of the flag to check for
 * @returns true if the flag is present, false otherwise
 */
export const hasFlag = (flagsString?: string, flagName?: string): boolean => {
  if (!flagName) return false;
  const flags = parseFlags(flagsString);
  return flags.has(flagName);
};
